export default __webpack_public_path__ + "static/media/bulkOrderUpgrade.71914368.svg";